import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getMemberStats } from 'src/shared/services/memberService';
import { ChartFailMessage } from 'src/modules/dashboard/components/atoms/chartFailMessage';
import { ContactsChart } from 'src/modules/dashboard/components/members/contactsChart';
import { MemberStats } from 'src/modules/dashboard/models/memberStats';
import { useDashboardFilter } from '../dashboardFilterContext';

export const ContactsChartWidget = () => {
  const isMounted = useIsMounted();
  const { associationId, districtId } = useDashboardFilter();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [stats, setStats] = useState<MemberStats>();

  useEffect(() => {
    setIsLoading(true);
    setHasError(false);
    const fetchData = async () => {
      try {
        const result = await getMemberStats(associationId, districtId);
        if (isMounted()) setStats(result.data);
      } catch (e) {
        if (isMounted()) {
          ConsoleHelper.error(e);
          setHasError(true);
        }
      } finally {
        if (isMounted()) setIsLoading(false);
      }
    };
    fetchData();
  }, [isMounted, associationId, districtId]);

  return (
    <Box sx={{ p: 2, height: '100%' }}>
      <ContactsChart memberStats={stats} isLoading={isLoading} />
      {hasError && <ChartFailMessage />}
    </Box>
  );
};
